import { ArrowRight, Dices, EyeOff, Link2, Smartphone, UserPlus, Users, Utensils } from 'lucide-react';
import { Link } from 'react-router';
import { BRAND } from '@shared/constants/brand';
import { AdSlot } from '@/components/AdSlot';
import { SideAds } from '@/components/SideAds';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

const STEPS = [
  { icon: Users, title: '방을 만들고', text: '인원과 닉네임만 정하면 끝. 회원가입은 없어요.' },
  { icon: Link2, title: '동료들을 초대하고', text: '링크 하나로 카톡, 슬랙 어디든 공유하세요.' },
  { icon: Dices, title: '돌아가며 메뉴를 선택하고', text: '무작위 순서로 한 단계씩, 다음 차례는 비밀!' },
  { icon: Utensils, title: '오늘의 점심을 결정하세요!', text: '배달·외식부터 최종 메뉴까지 4단계면 끝.' },
];

const FEATURES = [
  { icon: UserPlus, text: '회원가입 없이 바로 시작' },
  { icon: EyeOff, text: '다음 선택자는 비공개' },
  { icon: Dices, text: '모든 단계에서 랜덤 선택 가능' },
  { icon: Smartphone, text: '모바일 · PC 어디서나' },
];

export function HomePage() {
  useDocumentMeta({ path: '/' });
  return (
    <div className="flex flex-col gap-10">
      <SideAds />
      <section className="flex flex-col items-center pt-6 text-center animate-fade-up">
        <div className="mb-4 flex gap-2 text-4xl" aria-hidden="true">
          <span className="animate-bounce-soft">🍲</span>
          <span className="animate-bounce-soft [animation-delay:0.15s]">🍣</span>
          <span className="animate-bounce-soft [animation-delay:0.3s]">🍕</span>
        </div>
        <h1 className="text-4xl font-extrabold tracking-tight sm:text-5xl">{BRAND.name}</h1>
        <p className="mt-4 whitespace-pre-line text-base text-charcoal-500 sm:text-lg">{BRAND.subtitle}</p>
        {/* reloadDocument: 전체 페이지 이동으로 처리해 애드센스 전면 광고(Vignette)가 뜰 수 있게 함 */}
        <Link to="/create" reloadDocument className="btn-primary btn-lg mt-8 w-full max-w-xs animate-pulse-ring">
          오늘 점심 정하기
          <ArrowRight size={20} aria-hidden="true" />
        </Link>
        <p className="mt-3 text-xs text-charcoal-500">로그인 없이 10초면 방이 만들어져요</p>
      </section>

      <section aria-labelledby="how-it-works">
        <h2 id="how-it-works" className="mb-4 text-center text-lg font-bold">
          이렇게 사용해요
        </h2>
        <ol className="grid gap-3 sm:grid-cols-2">
          {STEPS.map((step, i) => (
            <li key={step.title} className="card flex items-start gap-3 p-4 animate-fade-up" style={{ animationDelay: `${i * 70}ms` }}>
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-50 text-primary-600">
                <step.icon size={20} aria-hidden="true" />
              </div>
              <div>
                <p className="font-bold">
                  <span className="mr-1.5 text-primary-500">{i + 1}.</span>
                  {step.title}
                </p>
                <p className="mt-0.5 text-sm text-charcoal-500">{step.text}</p>
              </div>
            </li>
          ))}
        </ol>
      </section>

      <section aria-label="특징" className="card p-5">
        <ul className="grid grid-cols-2 gap-3 text-sm">
          {FEATURES.map((f) => (
            <li key={f.text} className="flex items-center gap-2 text-charcoal-700">
              <f.icon size={16} className="shrink-0 text-primary-500" aria-hidden="true" />
              {f.text}
            </li>
          ))}
        </ul>
      </section>

      <section className="text-center">
        <p className="text-sm text-charcoal-500">점심시간마다 반복되는 "오늘 뭐 먹지?"</p>
        <p className="mt-1 font-semibold">{BRAND.slogan}</p>
        <Link to="/about" className="mt-3 inline-block text-sm text-primary-600 underline">
          서비스 소개와 자주 묻는 질문 보기
        </Link>
      </section>

      <AdSlot name="home" />
    </div>
  );
}
